import React from "react";

import Background from "../../../assets/lunch/lunch-bg-02.png";
import Image from "../../../assets/lunch/lunch-choice-b.png";

import GamePageLayout from "../GamePageLayout";

const LunchPage5 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("dinner-1")}
    >
      다 같이 먹는다는데,
      <br />
      빠지기 좀 애매하다.
      <br />
      그냥 먹자~
    </GamePageLayout>
  );
};

export default LunchPage5;
